// extracted by mini-css-extract-plugin
export var chip = "_4m-0";
export var filterDropdown = "_4m-5";
export var filterItem = "_4m-6";
export var icon = "_4m-1";
export var removeButton = "_4m-3";
export var removeIcon = "_4m-4";
export var separator = "_4m-2";